export enum ERodizioSessionStatus {
  Active = 0,
  Finished = 1,
  Canceled = 2,
}
